export default __webpack_public_path__ + "static/media/srisaialam.42e26a42.png";